// Bottom-nav tap pop. Each press replays the icon's spring (shared with the SPA
// router, which swaps only the page body — the bar itself persists).
(() => {
  document.addEventListener(
    'pointerdown',
    (event) => {
      const item = event.target.closest && event.target.closest('.bottom-nav__item');
      if (!item || item.classList.contains('bottom-nav__item--soon')) return;
      item.classList.remove('is-tapped');
      // Force a reflow so the animation restarts on a repeat tap.
      void item.offsetWidth;
      item.classList.add('is-tapped');
    },
    { passive: true }
  );

  document.addEventListener('animationend', (event) => {
    if (event.animationName !== 'bottom-nav-pop') return;
    const item = event.target.closest && event.target.closest('.bottom-nav__item');
    if (item) item.classList.remove('is-tapped');
  });
})();
